'use client';

import { useCallback } from 'react';

import { useCasinoLobby } from '@/features/v2/casino/hooks/useCasinoLobby';
import { UseGamesReturn } from '@/features/v2/casino/interfaces/game.interface';

export function useGames(): UseGamesReturn {
  const {
    games,
    loading,
    error,
    hasMore,
    totalCount,
    loadMore: originalLoadMore,
    loadGames,
  } = useCasinoLobby();

  const loadMore = useCallback(() => {
    originalLoadMore();
  }, [originalLoadMore]);

  const refetch = useCallback(() => {
    loadGames();
  }, [loadGames]);

  return {
    games,
    loading,
    error,
    hasMore,
    totalCount,
    loadMore,
    loadGames,
    refetch,
  };
}
